var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buybox" }, [
    _c(
      "button",
      {
        staticClass: "light-green",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            _vm.addCompany()
          }
        }
      },
      [
        _c("i", { staticClass: "ion-unlocked" }),
        _vm._v(
          "    Purchase " + _vm._s(_vm.company) + " pass for $19.95 / month\n\t"
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fc5d422", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc5d422","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BuyBox/BuyBox.vue
// module id = null
// module chunks = 